export const ROOT = 'categories';

export const FETCH_CATEGORIES_REQUEST = `${ROOT}/FETCH_CATEGORIES_REQUEST`;
export const FETCH_CATEGORIES_FAILURE = `${ROOT}/FETCH_CATEGORIES_FAILURE`;
export const FETCH_CATEGORIES_SUCCESS = `${ROOT}/FETCH_CATEGORIES_SUCCESS`;
